import {
  put
} from 'redux-saga/effects';
import axios from '../../axios-local-api';
import * as actions from '../actions';
import packageJson from '../../../package.json';

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
export function* initMobileHomeSaga(action) {
  // console.log('get mobile home')
  const rMac = yield sessionStorage.getItem('mac');
  let testObj = sessionStorage.getItem('testObj');

  yield put(actions.initMobileHomeStart());
  try {
    let response = {};
    const token = yield sessionStorage.getItem('token');
    const sessionToken = yield sessionStorage.getItem('sessionToken');
    yield sleep(5500);
    if (sessionToken) {
      response = yield axios.get(
        '/mobileHome'
      ).then(res => {
        if(testObj){
          let parsedTest = JSON.parse(testObj)
          if (parsedTest && parsedTest.vapEnabled) {
            res.data.vapEnabled = parsedTest.vapEnabled
          }
        }

        // console.log('RES MOB', res.data)
        return res.data

      })
    } else {
      // console.log('NO TOKEN')
      yield put(actions.fetchMobileHomeFailed());
    }
    yield put(actions.setMobileHome(response));
  } catch (error) {
    yield put(actions.fetchMobileHomeFailed());
  }
}
export function* changeMobileHomeSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const accountNumber = yield sessionStorage.getItem('accountNumber');
  let eventName;
  let eventType;


  const divId = yield sessionStorage.getItem('divId');
  const user = yield sessionStorage.getItem('userId');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      const response = yield axios.post(
        '/mobileHome',
        {
          mode: action.enabled ? 'enable' : 'disable'
        },
        {
          validateStatus: false
        }
      )
      // console.log('res chan', response)
      if (response.status.toString().substr(0, 1) === '2') {
        yield put(actions.initMobileHome(action))
        yield put(actions.changeMobileHomeSuccess());
      } else {
        // console.log('FAILED MOBILE HOME')
        yield put(actions.changeMobileHomeFailed(response.status));
      }



    } catch (error) {
      // console.error('FAILED MOBILE HOME')
      yield put(actions.changeMobileHomeFailed());
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.changeMobileHomeFailed());

  }

}

